module.exports = __webpack_public_path__ + "img/Foto_FachfrauBewegung_2016_9O1A6198_2019.ec897b60.jpg";